import PropTypes from 'prop-types';
import React from 'react';

import {MODELS_FILE_KEYS} from '@/modules/proposalRequest/contants/proposalRequest';
import {getModelDocDownloadUrl} from '@/utils/utils';

const mock = [
  MODELS_FILE_KEYS.MODELO_CAMBIOS_DE_CARGOS_DE_ORGANOS_SOCIALES_PARA_ELEVAR_A_PUBLICO,
  MODELS_FILE_KEYS.MODELO_CAMBIO_DENOMINACION_CAMBIO_DOMICILIO_CAMBIO_DE_OBJETO_INCREMENTO,
  MODELS_FILE_KEYS.MODELO_CAMBIOS_DE_CARGOS_DE_ORGANOS_SOCIALES_PARA_ELEVAR_A_PUBLICO,
  MODELS_FILE_KEYS.MODELO_INCORPORACION_DE_SOCIOS_POR_NUEVAS_APORTACIONES_QUE_CREAN,
  MODELS_FILE_KEYS.MODELO_OTROS_TRAMITES_NOTARIALES_PROTOCOLIZACION_DE_BALANCES_Y_OPERATORIA,
  MODELS_FILE_KEYS.MODELO_PARA_CEDER_PARTICIPACIONES
];

const HelpDocSection = ({options = mock}) => {
  return <div className='w-full mt-2 mb-4'>
    {options?.map((option, index) => (
      <div key={option || index}>
        <a href={getModelDocDownloadUrl(option)} target="_blank" className="truncate inline"
          rel="noreferrer">
          <span className="cursor-pointer text-primary" title={option}>
            {option}
          </span>
        </a>
      </div>))
    }
  </div>;
};

export default HelpDocSection;

HelpDocSection.propTypes = {
  options: PropTypes.array,
};
